const types = [
  {
    type: "E",
    description:
      "Extraversion (E): Người hướng ngoại thường thích giao tiếp và tương tác với thế giới bên ngoài, tìm kiếm sự kích thích từ môi trường xung quanh. Họ năng động, hướng tới các hoạt động nhóm.",
  },
  {
    type: "I",
    description:
      "Introversion (I): Người hướng nội thường thích suy nghĩ, độc lập và dành thời gian một mình. Họ cảm thấy nạp lại năng lượng khi ở trong môi trường yên tĩnh và ít ồn ào.",
  },
  {
    type: "S",
    description:
      "Sensing (S): Người thuộc loại này thích tập trung vào những chi tiết cụ thể và thực tế. Họ chú trọng vào việc quan sát và sử dụng kinh nghiệm trong quá khứ.",
  },
  {
    type: "N",
    description:
      "Intuition (N): Người thuộc loại này thích khám phá các khái niệm, ý tưởng và khả năng trong tương lai. Họ thường nhìn vào bức tranh toàn cảnh hơn là những chi tiết nhỏ.",
  },
  {
    type: "T",
    description:
      "Thinking (T): Những người này đưa ra quyết định dựa trên lý trí, logic và sự phân tích khách quan. Họ đánh giá tình huống dựa trên sự công bằng và chính xác.",
  },
  {
    type: "F",
    description:
      "Feeling (F): Những người này đưa ra quyết định dựa trên cảm xúc, giá trị cá nhân và sự quan tâm đến người khác. Họ đánh giá tình huống dựa trên sự hòa hợp và tình cảm.",
  },
  {
    type: "J",
    description:
      "Judging (J): Người thuộc loại này thích có kế hoạch, tổ chức và cấu trúc trong cuộc sống. Họ thích làm việc có mục tiêu và có xu hướng hoàn thành công việc trước khi thư giãn.",
  },
  {
    type: "P",
    description:
      "Perceiving (P): Người thuộc loại này thường linh hoạt và có xu hướng để mọi thứ mở rộng. Họ thích thích ứng với tình huống thay vì ép buộc mọi thứ theo kế hoạch cố định.",
  },
];
export default types;
